import { BrowserAuthError, InteractionRequiredAuthError, } from '@azure/msal-browser';
import { getMsalRedirectUri, graphReadScopes, graphScopes, } from '@/auth/MsalConfig';
/** Thrown when MSAL starts a full-page redirect for mailbox consent. */
export class GraphAuthRedirectPendingError extends Error {
    constructor() {
        super('Redirecting to Microsoft to grant mailbox access…');
        this.name = 'GraphAuthRedirectPendingError';
    }
}
function needsInteractiveAuth(err) {
    if (err instanceof InteractionRequiredAuthError)
        return true;
    if (err instanceof BrowserAuthError) {
        const code = err.errorCode || '';
        return (code === 'popup_window_error' ||
            code === 'user_cancelled' ||
            code === 'interaction_in_progress' ||
            /popup|interaction_required|consent_required|login_required/i.test(`${code} ${err.message}`));
    }
    const msg = err instanceof Error ? err.message : String(err);
    return /popup_window_error|interaction_required|consent_required|AADSTS65001/i.test(msg);
}
async function acquireWithScopes(instance, account, scopes) {
    const redirectUri = getMsalRedirectUri();
    try {
        const result = await instance.acquireTokenSilent({ scopes, account });
        return result.accessToken;
    }
    catch (err) {
        if (needsInteractiveAuth(err)) {
            // Hostinger / blocked popups: never use popup — full-page redirect only
            await instance.acquireTokenRedirect({
                scopes,
                account,
                redirectUri,
            });
            throw new GraphAuthRedirectPendingError();
        }
        throw err;
    }
}
/**
 * Graph access token for mailbox.
 * Tries Mail.ReadWrite first; falls back to Mail.Read so inbox can still load.
 * Interactive consent uses redirect (not popup) so Hostinger works.
 */
export async function acquireGraphAccessToken(instance, account) {
    try {
        return await acquireWithScopes(instance, account, graphScopes);
    }
    catch (writeErr) {
        if (writeErr instanceof GraphAuthRedirectPendingError)
            throw writeErr;
        console.warn('[graph] Mail.ReadWrite unavailable — trying Mail.Read', writeErr);
        return acquireWithScopes(instance, account, graphReadScopes);
    }
}
